import { memo, ReactElement } from 'react';
import { FormSpy as FinalFormSpy } from 'react-final-form';

import { TextFieldWithPrefix } from '../TextFieldWithPrefix/TextFieldWithPrefix';
import { INPUT_LABEL, INPUT_MAX_LENGTH } from './DeepLinkAliasField.constants';
import styles from './DeepLinkAliasField.styles.m.css';
import { IDeepLinkAliasFieldProps } from './DeepLinkAliasField.types';

export const DeepLinkAliasField = memo<IDeepLinkAliasFieldProps>((props) => {
  const {
    title,
    description,
    label = INPUT_LABEL,
    maxLength = INPUT_MAX_LENGTH,
    placeholder,
    validatingText,
    successText,
    isShowLink,
    input,
    meta,
  } = props;

  return (
    <FinalFormSpy
      subscription={{
        values: true,
      }}
    >
      {({ values }): ReactElement | null => {
        if (isShowLink && !isShowLink(values)) {
          return null;
        }

        return (
          <div className={styles.container}>
            <p className={styles.title}>{title}</p>
            <p className={styles.description}>{description}</p>
            <TextFieldWithPrefix
              label={label}
              placeholder={placeholder}
              component={TextFieldWithPrefix}
              maxLength={maxLength}
              validatingText={validatingText}
              successText={successText}
              input={input}
              meta={meta}
            />
          </div>
        );
      }}
    </FinalFormSpy>
  );
});
